// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ActorType,
  ClientType,
} from "./types";

export default {
  displayName: __t.string(),
  avatarColor: __t.option(__t.string()),
  get clientType() {
    return ClientType;
  },
  clientVersion: __t.string(),
  get actorType() {
    return ActorType;
  },
  agentType: __t.option(__t.string()),
  associatedTwinId: __t.option(__t.string()),
};
